<template>
    <div class="item-container">
        <div class="title">
            <div class="title-main">
                <i class="el-icon-caret-bottom" :style="{marginRight: '10px'}" v-if="isShow" @click="isShow = !isShow"></i>
                <i class="el-icon-caret-right" :style="{marginRight: '10px'}" v-else @click="isShow = !isShow"></i>
                <span class="id-text" @click="isShow = !isShow">服务ID: {{item.id}}</span>
                <img src="../../assets/images/copy.png" alt=""
                     v-if="isEditMode"
                     title="复制" class="copy-icon" :data-clipboard-text="item.id"/>

            </div>
            <el-button type="text" v-if="isEditMode" class="title-btn" @click="$emit('remove')">删除服务</el-button>
            <div v-else></div>
        </div>
        <div class="content" :style="{height: isShow ? 'auto' : 0}">
            <p :style="{ marginTop: '24px', marginBottom: '20px'}"><span :style="{color: '#999999'}">服务类型 </span><span :style="{wordBreak: 'break-all'}">{{item.type}}</span></p>
            <p :style="{marginBottom: '17px', }"><span :style="{color: '#999999'}">服务描述 </span><span :style="{wordBreak: 'break-all'}">{{item.description || '-'}}</span></p>
            <el-button size="small" :style="{marginBottom: '12px'}" @click="addAttr" v-if="isEditMode">添加属性</el-button>
            <div class="divider"></div>
            <el-table :style="{width: '100%'}" :data="item.properties">
                <el-table-column label="属性名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="ellipsis">{{scope.row.name || '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="数据类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="ellipsis">{{scope.row.propertyType | parsePropertyType}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="必选" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="ellipsis">{{scope.row.isRequired.toString() || '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="访问权限" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="ellipsis">{{scope.row.access | parseAccess}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" v-if="isEditMode">
                    <template v-slot="{row}">
                        <el-button type="text" @click="copy(row)">复制</el-button>
                        <el-button type="text" @click="edit(row)">修改</el-button>
                        <el-button type="text" @click="remove(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-button size="small" :style="{marginTop: '22px', marginBottom: '12px'}" @click="addCommand" v-if="isEditMode">添加命令</el-button>
            <div class="divider"></div>
            <el-table :style="{width: '100%', marginBottom: '24px'}" :data="item.commands">
                <el-table-column label="命令名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="ellipsis">{{scope.row.name || '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="下发参数" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="ellipsis">{{scope.row.inputParameters&&scope.row.inputParameters.map(item => item.name).join(',') || '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="响应参数" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="ellipsis">{{scope.row.outputParameters&&scope.row.outputParameters.map(item => item.name).join(',') || '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" v-if="isEditMode">
                    <template v-slot="{row}">
                        <el-button type="text" @click="copyCommand(row)">复制</el-button>
                        <el-button type="text" @click="editCommand(row)">修改</el-button>
                        <el-button type="text" @click="removeCommand(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <edit-attribute-dialog ref="editAttributeDialog"/>
        <add-command-dialog ref="addCommandDialog"/>
    </div>
</template>

<script>
    import editAttributeDialog from "./editAttributeDialog";
    import addCommandDialog from "./addCommandDialog";
    export default {
        name: "serviceItem",
        props: {
            item: Object,
            isEditMode: Boolean,
            isCallMode: Boolean,
            index: Number,
            clipboard: Object,
        },
        components: {
            editAttributeDialog,
            addCommandDialog
        },
        data() {
            return {
                isShow: false,
            }
        },
        methods: {
            async copy(data) {
                let copy = Object.assign({}, data);
                copy.name = '';
                delete copy.id;
                let res = await this.$refs.editAttributeDialog.show(copy, this.item.properties&&this.item.properties.map(item => item.name) || [])
                if (res === null) {
                    return;
                }
                res.serveId = this.item.id;
                if (this.isCallMode) {
                    this.$emit('addAttr', res)
                } else {
                    this.item.properties.push(res);
                }
            },
            async edit(data) {
                let res = await this.$refs.editAttributeDialog.show(Object.assign({}, data),
                    this.item.properties&&this.item.properties.filter(item => item.name !== data.name).map(item => item.name) || [])
                if (res === null) {
                    return;
                }
                if (this.isCallMode) {
                    this.$emit('editAttr', res)
                } else {
                    let index = this.item.properties.indexOf(data);
                    if (index === -1) {
                        return
                    }
                    this.$set(this.item.properties, index, res);
                }
            },
            remove(data) {
                this.$confirm(`是否删除${this.item.id}(服务类型)下名称为${data.name}的服务属性？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    closeOnClickModal:false
                }).then(async () => {
                    if (this.isCallMode) {
                        this.$emit('removeAttr', {
                            propertyId: data.id,
                            serveId: this.item.id
                        });
                    } else {
                        let index = this.item.properties.indexOf(data);
                        if (index === -1) {
                            return;
                        }
                        this.item.properties.splice(index, 1)
                    }

                }).catch(err=>{})
            },
            async copyCommand(data) {
                let copy = Object.assign({}, data);
                copy.inputParameters = Object.assign([], copy.inputParameters);
                copy.outputParameters = Object.assign([], copy.outputParameters);
                copy.name = '';
                delete copy.id;
                let res = await this.$refs.addCommandDialog.show(copy, this.item.commands&&this.item.commands.map(item => item.name)||[]);
                if (res === null) {
                    return;
                }
                res.serveId = this.item.id;
                if (this.isCallMode) {
                    this.$emit('addCommand', res)
                } else {
                    this.item.commands.push(res);
                }
            },
            async editCommand(data) {
                let copy = Object.assign({}, data);
                copy.inputParameters = Object.assign([], copy.inputParameters);
                copy.outputParameters = Object.assign([], copy.outputParameters);
                let res = await this.$refs.addCommandDialog.show(data, this.item.commands&&this.item.commands.filter(item => item.name !== data.name).map(item => item.name)||[]);
                if (res === null) {
                    return;
                }
                if (this.isCallMode) {
                    this.$emit('editCommand', res)
                } else {
                    let index = this.item.commands.indexOf(data);
                    if (index === -1) {
                        return
                    }
                    this.$set(this.item.commands, index, res);
                }
            },
            removeCommand(data) {
                this.$confirm(`是否删除${this.item.id}(服务类型)下名称为${data.name}的服务命令？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    closeOnClickModal:false
                }).then(async () => {
                    if (this.isCallMode) {
                        this.$emit('removeCommand', {
                            commandId: data.id,
                            serveId: this.item.id
                        });
                    } else {
                        let index = this.item.commands.indexOf(data);
                        if (index === -1) {
                            return;
                        }
                        this.item.commands.splice(index, 1)
                    }
                }).catch(err=>{})
            },
            async addCommand() {
                let res = await this.$refs.addCommandDialog.show(undefined, this.item.commands&&this.item.commands.map(item => item.name)||[]);
                if (res === null) {
                    return;
                }
                res.serveId = this.item.id;
                if (this.isCallMode) {
                    this.$emit('addCommand', res)
                } else {
                    if(!this.item.commands) {
                        this.$set(this.item, 'commands', [])
                    }
                    this.item.commands.push(res);
                }
            },
            async addAttr() {
                let res = await this.$refs.editAttributeDialog.show(undefined, this.item.properties&&this.item.properties.map(item => item.name)||[])
                if (res === null) {
                    return;
                }
                res.serveId = this.item.id;
                if (this.isCallMode) {
                    this.$emit('addAttr', res)
                } else {
                    if (!this.item.properties) {
                        this.$set(this.item, 'properties', [])
                    }
                    this.item.properties.push(res);
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .item-container{
        width: 100%;
        font-size: 14px;
    }
    .title{
        width: 100%;
        height: 52px;
        background-color: #FAFAFA;
        border: 1px solid #E8E8E8;
        display: flex;
        align-items: center;
        padding: 0 30px;
        box-sizing: border-box;
    }
    .title-main{
        flex: 1;
        display: flex;
        justify-content: left;
        align-items: center;
    }
    .title-main>*{
        margin-right: 4px;
    }
    .title-main>img{
        cursor: pointer;
    }
    .content{
        width: 100%;
        box-sizing: border-box;
        border-left: 1px solid #E8E8E8;
        border-right: 1px solid #E8E8E8;
        border-bottom: 1px solid #E8E8E8;
        transition: all .3s;
        overflow: hidden;
        padding: 0 24px;
    }
    .id-text{
        font-size: 16px;
        font-weight: 600;
    }
    .el-table{
    border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
}
</style>